const state = () => ({
  webPages: {},
  webPageIds: [],
});

const getters = {
  webPages: state => state.webPages,
  webPageList: state => state.webPageIds.map(id => state.webPages[id]),
};

const mutations = {
  setWebPages: function(state, pages) {
    pages.forEach(card => {
      state.webPages[card.id] = card;
      if(!state.webPageIds.includes(card.id)) {
        state.webPageIds.push(card.id);
      }
    });
  },
};

const actions = {
  loadWebPages({ dispatch, commit, getters, rootGetters }) {
    return rootGetters['session/ajax'].get('/web_pages').then(response => {
      if (response.data.records) {
        commit('setWebPages', response.data.records);
        return response.data.records;
      } else {
        commit('setWebPages', response.data.webPages);
        return response.data.webPages;
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
